import { useEffect, useState } from "react";
import { entraNoAccessMessage } from "@/lib/entraAuth";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AlertCircle, Loader2, Lock } from "lucide-react";

export default function EntraCallback() {
  const { completeEntraHandoff } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await completeEntraHandoff();
      if (cancelled) return;
      if (result.success) {
        window.location.replace("/");
        return;
      }
      setError(entraNoAccessMessage(result.error || "Sign-in failed. Try again."));
    })();
    return () => {
      cancelled = true;
    };
  }, [completeEntraHandoff]);

  return (
    <div className="min-h-screen bg-cp-page flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-cp-line shadow-cp">
        <CardHeader className="space-y-1 pb-4">
          <div className="mx-auto mb-2 inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-cp-grad shadow-cp-accent">
            <Lock className="h-6 w-6 text-white" />
          </div>
          <CardTitle className="text-xl text-cp-fg text-center">Halo</CardTitle>
          <CardDescription className="text-cp-muted text-center">
            {error ? "Could not finish Microsoft sign-in" : "Finishing sign-in…"}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {error ? (
            <div className="space-y-4">
              <div className="flex items-start gap-2 p-3 bg-[color-mix(in_srgb,var(--crit)_12%,transparent)] border border-[color-mix(in_srgb,var(--crit)_25%,transparent)] rounded-lg text-cp-crit text-sm">
                <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
                <span>{error}</span>
              </div>
              <Button
                type="button"
                className="w-full"
                onClick={() => {
                  window.location.replace("/");
                }}
                data-testid="entra-callback-retry"
              >
                Back to sign in
              </Button>
            </div>
          ) : (
            <div className="flex items-center justify-center gap-2 text-cp-muted py-4">
              <Loader2 className="h-4 w-4 animate-spin" />
              Completing Microsoft sign-in
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
